import { App } 		from 'vue'
import { Options } 	from './types'
import WLoadable	from './_components/w-loadable.vue'

export const skelet = (data, count) => {
	if (data) return data

	return Array(count).fill(null)
}

export const skeletRandomWidth = (min, max) => {
	return Math.floor(Math.random() * (max - min + 1)) + min
}

export default {
	install: (app: App, options: Options = {}) => {
		if (options && options.disabled === true)
			return

		app.component('W-loadable', WLoadable)

		app.config.globalProperties.$skelet = skelet
		app.config.globalProperties.$skeletRandomWidth = skeletRandomWidth
	}
}
